import { Box, Flex, Icon, Text, Tooltip } from '@chakra-ui/react'
import { cnpjMask } from '../../../utils/cnpjMask'
import { useModalCallPhone } from '../../../contexts/CallPhoneContext'
import { AiOutlineWhatsApp } from 'react-icons/ai'
import { maskPhone } from '../../../utils/maskPhone'
import { cepMask } from '../../../utils/cepMask'

export function Faturamento({ dadosFaturamento }) {
    const { openCallPhone } = useModalCallPhone()

    return (
        <Box
            gridColumn={{
                base: 'span 12',
                md: 'span 4',
            }}
            border="1px solid #7fb603"
        >
            <Text textAlign="center" color="#fff" bg="#7fb603">
                DADOS DO FATURAMENTO
            </Text>

            <Flex flexDir="column" gap={1} p={3}>
                <Text maxW="400px" isTruncated>
                    <b>Razão Social: </b>
                    <Tooltip label={dadosFaturamento.razao_social} aria-label="A tooltip">
                        <Text textTransform="capitalize" as="span">
                            {dadosFaturamento.razao_social}
                        </Text>
                    </Tooltip>
                </Text>
                <Text>
                    <b>CNPJ: </b> {cnpjMask(dadosFaturamento.cnpj)}
                </Text>
                <Text>
                    <b>IE: </b> {dadosFaturamento.inscricao_estadual}
                </Text>
                <Text textTransform="capitalize">
                    <b>Endereço:</b> {dadosFaturamento.endereco}
                </Text>
                <Text>
                    <b>CEP:</b> {cepMask(dadosFaturamento.cep)}
                </Text>
                <Text textTransform="capitalize">
                    <b>Cidade/UF:</b> {dadosFaturamento.cidade}/{dadosFaturamento.sigla}
                </Text>
                <Text textTransform="capitalize">
                    <b>Nome:</b> {dadosFaturamento.nome_parceiro}
                </Text>
                <Text>
                    <b>Email:</b> {dadosFaturamento.email_parceiro}
                </Text>
                <Text cursor="pointer" onClick={() => openCallPhone(dadosFaturamento.telefone)}>
                    <b>Tel:</b> {maskPhone(dadosFaturamento.telefone)}
                </Text>
                <Flex justifyContent="space-between" alignItems="center">
                    <Text cursor="pointer" onClick={() => openCallPhone(dadosFaturamento.telefone)}>
                        <b>Cel:</b> {maskPhone(dadosFaturamento.celular)}{' '}
                    </Text>
                    <Text as="a" href={dadosFaturamento.link_whats} target="_blank">
                        <Icon as={AiOutlineWhatsApp} display="inline" ml={2} fontSize="20px" color="#25D366" />
                    </Text>
                </Flex>
            </Flex>
        </Box>
    )
}
